import apiUrl from '../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect';
import { BasicSelect } from 'vue-search-select';
import user_tracker from '../../../../usertracker'
import {
    buildConnectionsSearchPayload,
    CONNECTION_SEARCH_PURPOSE,
    getConnectionsSearchUrl
} from '../../../../utils/connectionsSearchApi.js';

export default {
    name: 'AllocateGroupsToConnection',
    components: {
        BasicSelect,
        VueElementLoading,
        Multiselect
    },
    data: function () {
        return {
            isLoading: false,
            city: ``,
            cityid: ``,
            cityname: ``,
            routemodeList: [{
                text: "Surface"
            }, {
                text: "Air"
            }],
            selectedRouteMode: ``,
            groupsList: [],
            cityList: [],
            hubLoading: '',
            HubList: [],
            connectionTypeList: [{
                value: "LC",
                text: "Local Connection",
                id: 1
            }, {
                value: "LHC",
                text: "LineHaul Connection",
                id: 3
            }],
            connectionTypeObjData: {
                value: "",
                text: ""
            },
            connectionObjData: {
                value: "",
                text: ""
            },
            originHubObjData: {
                value: "",
                text: ""
            },
            originHubID: ``,
            originHubName: ``,
            hubName: ``,
            connectionid: ``,
            connectionname: ``,
            connectionTypeID: ``,
            connectionList: [],
            checkAllGroups: false,
            confirmationModal: false,
            isConnLoading: false,
            allowBagpattern: false,
            selectedgroups: [],
            resetCalled: false,
            groupTypeList: [{
                value: '1',
                text: "City"
            },
            {
                value: '2',
                text: "Rest Of City"
            },
            {
                value: '3',
                text: "RTO"
            },
            {
                value: '4',
                text: "Rest of RTO"
            }],
            groupTypeObjData: {
                value: "",
                text: ""
            },
            groupType: '',
            userData:[]
        }
    },
    created: function () { },
    computed: {},
    mounted() {
        let userdetailEncrypt = window.localStorage.getItem('userdetail');
        let bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        let plaintext = bytes.toString(CryptoJS.enc.Utf8);
        let userdetail = JSON.parse(plaintext);
        this.userData = userdetail;
        this.useremail = userdetail[0].email;
        this.fetchAllGroups();
        this.getCityList();
        this.getHubList();
    },
    methods: {
        fetchAllGroups() {
            this.isLoading = true;
            this.groupsList = [];
            this.checkAllGroups = false;
            let payload = {};
            if (this.selectedRouteMode.length > 0)
                payload.routename = [...new Set(this.selectedRouteMode.map(a => a.text))];
            if (this.cityid != ``)
                payload.cityid = this.cityid;
            if (this.groupType != ``)
                payload.grouptype = this.groupType;
            axios({
                method: 'POST',
                'url': apiUrl.api_url_hubops + 'fetchAllGroups',
                'data': payload,
                headers: {
                    'authorization': 'authkey xB84JJ89Hd25'
                }
            }).then(result => {
                this.isLoading = false;
                if (result.data.ResultCode == 100) {
                    this.groupsList = result.data.ResponseData;
                    if (!this.resetCalled) {
                        this.$alertify.success(result.data.ReturnMessage);
                        this.resetCalled = false;
                    }
                } else {
                    this.$alert(result.data.ReturnMessage, "", "error");
                }
            }, error => {
                this.isLoading = false;
                console.error(error);
            })
        },
        getCityList() {
            axios({
                method: 'POST',
                'url': apiUrl.api_url_hubops + 'allcity/get',
                'data': ({}),
                headers: {
                    'authorization': 'authkey xB84JJ89Hd25',
                }
            }).then(result => {
                let cityList = result.data.ResponseData;
                for (const element of cityList) {
                    this.cityList.push({
                        value: element.cityid,
                        text: element.cityname
                    })
                }
            }, error => {
                console.error(error);
            })
        },
        getHubList() {
            this.HubList = [];
            this.hubLoading = 'Loading Hub...';
            axios({
                method: 'POST',
                'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
                'data': ({}),
                headers: {
                    'authorization': 'authkey xB84JJ89Hd25',
                }
            }).then(result => {
                this.hubLoading = '';
                let hubList = result.data.ResponseData;
                for (const element of hubList) {
                    this.HubList.push({
                        value: element.HubID,
                        text: element.HubName + ' (' + element.HubID + ')'
                    })
                }
            }, error => {
                this.hubLoading = '';
                console.error(error);
            })
        },
        getConnectionList() {
            this.isConnLoading = true;
            this.connectionList = [];
            this.input = buildConnectionsSearchPayload(CONNECTION_SEARCH_PURPOSE.BAGGING, {
                type: this.connectionTypeID,
                source: this.originHubID
            })
            axios({
                method: 'POST',
                url: getConnectionsSearchUrl(),
                data: this.input,
                headers: {
                    'authorization': 'authkey xB84JJ89Hd25',
                    'requestfrom': "WEB",
                    'token': this.token
                }
            }).then(result => {
                this.isConnLoading = false;
                if (result.data.ResultCode == 100) {
                    let connectionData = result.data.ResponseData;
                    for (const element of connectionData) {
                        this.connectionList.push({
                            value: element.ConnectionID,
                            text: element.ConnectionName
                        })
                    }
                } else {
                    this.$alertify.error(result.data.ReturnMessage);
                }
            }, error => {
                this.isConnLoading = false;
                console.error(error)
            })
        },
        selectedCity(cityData) {
            this.cityObjData = cityData;
            this.cityid = cityData.value;
            this.cityname = cityData.text;
        },
        updateselected() {
            this.checkAllGroups = false;
            let selectedgroups = this.groupsList.filter(item => item.isselected);
            if (selectedgroups.length == this.groupsList.length) {
                this.checkAllGroups = true;
            }
        },
        mapconnectiontogroups() {
            this.confirmationModal = false;
            this.input = ({
                groupid: this.selectedgroups,
                connectiontype: this.connectionTypeCode,
                originhubid: this.originHubID,
                originhubname: this.originHubName,
                isbaggingpattern: this.allowBagpattern,
                connectionid: this.connectionid,
                connectionname: this.connectionname,
                createdby: this.useremail
            });
            if (this.cityid) {
                this.input.cityid = this.cityid;
                this.input.cityname = this.cityname;
            }
            this.isLoading = true;
            axios({
                method: 'POST',
                'url': apiUrl.api_url_hubops + 'mapconnectiontogroups',
                'data': this.input,
                headers: {
                    'authorization': 'authkey xB84JJ89Hd25',
                }
            }).then(result => {
                this.isLoading = false;
                if (result.data.ResultCode == 100) {
                    this.$alert(result.data.ReturnMessage, "", "success");
                    user_tracker.checkUserIP(this.userData[0], "AllocateGroupsToConnection", this.$route.path , this.input);
                    // this.resetForm();
                } else {
                    this.$alert(result.data.ReturnMessage, "", "error");
                }
            }, error => {
                this.isLoading = false;
                console.error(error)
            })
        },
        closeModal() {
            this.confirmationModal = false;
        },
        checkGroup() {
            if (this.checkAllGroups) {
                for (const element of this.groupsList) {
                    element.isselected = true;
                }
            } else {
                for (const element of this.groupsList) {
                    element.isselected = false;
                }
            }
        },
        selectedConnectionType(connectionTypeData) {
            this.connectionTypeObjData = connectionTypeData;
            this.connectionTypeID = connectionTypeData.id;
            this.connectionTypeCode = connectionTypeData.value;
            if (this.connectionTypeID && this.originHubID)
                this.getConnectionList();
        },
        selectedOriginHub(hubData) {
            this.originHubObjData = hubData;
            this.originHubID = hubData.value;
            this.originHubName = hubData.text;
            if (this.connectionTypeID && this.originHubID)
                this.getConnectionList();
        },
        selectedConnection(connectionData) {
            this.connectionObjData = connectionData;
            this.connectionid = connectionData.value;
            this.connectionname = connectionData.text;
        },
        onSubmitSearch: function () {
            this.$validator.validateAll('form-1').then((result) => {
                if (!result) {
                    return false;
                }
                this.selectedgroups = this.groupsList.filter(function (i) {
                    return i.isselected;
                }).map(function (i) {
                    return i.groupid;
                });
                if (this.selectedgroups.length == 0) {
                    this.$alertify.error("Please select at least one group!!");
                    return false;
                }
                this.confirmationModal = true;

            }).catch((error) => {
                console.error(error);
            });
        },
        resetForm() {
            this.isLoading = false;
            this.city = ``;
            this.cityid = ``;
            this.cityname = ``;
            this.selectedRouteMode = ``;
            this.groupsList = [];
            this.hubLoading = '';
            this.connectionTypeObjData = {
                value: "",
                text: ""
            };
            this.connectionObjData = {
                value: "",
                text: ""
            };
            this.originHubObjData = {
                value: "",
                text: ""
            };
            this.originHubID = ``;
            this.originHubName = ``;
            this.hubName = ``;
            this.connectionid = ``;
            this.connectionname = ``;
            this.connectionTypeID = ``;
            this.connectionList = [];
            this.checkAllGroups = false;
            this.confirmationModal = false;
            this.isConnLoading = false;
            this.allowBagpattern = false;
            this.selectedgroups = [];
            this.resetCalled = false;
            this.groupType = ``;
            this.groupTypeObjData = {
                value: "",
                text: ""
            };
            this.$validator.reset();
        },
        resetDiv() {
            this.allowBagpattern = false;
            this.connectionObjData = {
                value: "",
                text: ""
            };
            this.connectionTypeObjData = {
                value: "",
                text: ""
            };
            this.originHubObjData = {
                value: "",
                text: ""
            };
            this.originHubID = ``;
            this.originHubName = ``;
            this.hubName = ``;
            this.connectionid = ``;
            this.connectionname = ``;
            this.connectionTypeID = ``;
            this.connectionList = [];
            this.$validator.reset();
        },
        resetFilter() {
            this.cityid = ``;
            this.city = ``;
            this.selectedRouteMode = ``;
            this.groupType = ``;
            this.groupTypeObjData = {
                value: "",
                text: ""
            };
            this.resetCalled = true;
            this.fetchAllGroups();
        },
        selectedGroupType(groupData) {
            this.groupTypeObjData = groupData;
            this.groupType = groupData.value;
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/groupnew/AllocateGroupsToConnection/AllocateGroupsToConnection.js